@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngClass]="{ 'dark-backroun-main': selectedMode === 'dark' }">
  <div class="container-fluid mb-4 " >


    <div class="tablewidth mt-0">
      <table class="bg-white">
        <tr id="tableHead" class="loan-heading">
          <th class="text-center" colspan="2">User Loan Detail</th>
        </tr>
        <tr id="tableHead" class="tableHead">
          <th class="">Name</th>
          <td>Shahrukh afzal</td>
        </tr>
        <tr class="tableHead">
          <th class="">Total Amount</th>
          <td class=""></td>
        </tr>
        <tr class="tableHead">
          <th class="">Monthly Installment</th>
          <td class=""></td>
        </tr>
        <tr class="tableHead">
          <th class="">Total Installments</th>
          <td class=""></td>
        </tr>
        <tr class="tableHead">
          <th class="">Remaining Amount</th>
          <td class=""></td>
        </tr>
        <tr class="tableHead">
          <th class="">Remaining Months</th>
          <td class=""></td>
        </tr>

        <tr class="tableHead">
          <th class="">Remaining Months</th>
          <td class=""></td>
        </tr>



      </table>
    </div>

  </div>
</main>